import { render } from "./DATE_OF_BIRTH_SELECTION.vue?vue&type=template&id=02433476&scoped=true"
import script from "./DATE_OF_BIRTH_SELECTION.vue?vue&type=script&lang=js"
export * from "./DATE_OF_BIRTH_SELECTION.vue?vue&type=script&lang=js"

import "./DATE_OF_BIRTH_SELECTION.vue?vue&type=style&index=0&id=02433476&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02433476"]])

export default __exports__